import { Controller } from "stimulus";

export default class Toast extends Controller {
	connect() {
		console.log("connect");
		this.element.addEventListener(
			"animationend",
			({ animationName }: AnimationEvent) => {
				if (animationName == "fade-out") {
					this.element.parentElement?.removeChild(this.element);
				}
			}
		);
	}
}
